var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningHatFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 2.09l11 5a.998.998 0 010 1.82l-11 5a1 1 0 01-.828 0l-11-5a.998.998 0 01.001-1.82l11-5c.263-.119.564-.119.827 0zM24 11h-2v6h2v-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.241 15.73c-.394.18-.811.27-1.241.27-.43 0-.847-.09-1.24-.269L4 12.658V18c0 2.626 4.024 4 8 4s8-1.374 8-4v-5.34l-6.759 3.07z"
  })));
}
export default SvgLearningHatFill;